import { MenuItem as MUIMenuItem } from '@mui/material';

/**
 * Project alias for MUI's MenuItem. Import from here instead of
 * `@mui/material` so the whole app tracks one implementation. All MUI
 * MenuItem props pass through.
 */
const MenuItem = props => <MUIMenuItem {...props} />;

export default MenuItem;
